export const PROJECT_STORAGE_KEY = 'projects'
export const PROJECT_LIST_STORAGE_KEY = 'projects-list'
export const PROJECT_PHASE_STORAGE_KEY = 'projects-phase'
export const PROJECT_DETAILS_LINK = 'https://my.1tool.com/projects/details'

export enum PROJECT_COLUMN {
  ACTION = 'ACTION',
  NAME = 'NAME',
  MANAGER = 'MANAGER',
  SALER = 'SALER',
  START_DATE = 'START_DATE',
  END_DATE = 'END_DATE',
  NUMBER = 'NUMBER',
  ACTIVE = 'ACTIVE',
  UPDATED = 'UPDATED',
  STREET = 'STREET',
  ZIP = 'ZIP',
  CITY = 'CITY',
  LONGITUDE = 'LONGITUDE',
  LATITUDE = 'LATITUDE',
  COUNTRY = 'COUNTRY',
  PHASE = 'PHASE',
  MAIN_CUSTOMER = 'MAIN_CUSTOMER'
}

export enum PROJECT_FILTER {
  SEARCH = 'SEARCH',
  ACTIVE = 'ACTIVE',
  MANAGER = 'MANAGER',
  SALER = 'SALER',
  PHASE = 'PHASE',
  STREET = 'STREET',
  ZIP = 'ZIP',
  CITY = 'CITY',
  LONGITUDE = 'LONGITUDE',
  LATITUDE = 'LATITUDE',
  COUNTRY = 'COUNTRY',
  TYPE = 'TYPE',
  DEPARTMENT = 'DEPARTMENT',
  MAIN_CUSTOMER = 'MAIN_CUSTOMER'
}

export enum LAYOUT_FIELD_TYPE {
  Headline = 1,
  Text = 2,
  Customer = 3,
  Dynamic = 4
}

export function getProjectFilterOptions(t: ReturnType<typeof useL10n>['t']) {
  return [
    {
      label: t('global.action.search'),
      value: PROJECT_FILTER.SEARCH
    },
    {
      label: t('pages.projects.manager'),
      value: PROJECT_FILTER.MANAGER
    },
    {
      label: t('pages.projects.department'),
      value: PROJECT_FILTER.DEPARTMENT
    },
    {
      label: t('pages.projects.mainCustomer'),
      value: PROJECT_FILTER.MAIN_CUSTOMER
    },
    {
      label: t('pages.projects.saler'),
      value: PROJECT_FILTER.SALER
    },
    {
      label: t('pages.projects.active'),
      value: PROJECT_FILTER.ACTIVE
    },
    {
      label: t('pages.projects.type'),
      value: PROJECT_FILTER.TYPE
    },
    {
      label: t('pages.projects.phase'),
      value: PROJECT_FILTER.PHASE
    },
    {
      label: t('pages.projects.street'),
      value: PROJECT_FILTER.STREET
    },
    {
      label: t('pages.projects.zip'),
      value: PROJECT_FILTER.ZIP
    },
    {
      label: t('pages.projects.city'),
      value: PROJECT_FILTER.CITY
    },
    {
      label: t('pages.projects.country'),
      value: PROJECT_FILTER.COUNTRY
    },
    {
      label: t('pages.projects.longitude'),
      value: PROJECT_FILTER.LONGITUDE
    },
    {
      label: t('pages.projects.latitude'),
      value: PROJECT_FILTER.LATITUDE
    }
  ]
}

export function getProjectColumnOptions(t: ReturnType<typeof useL10n>['t']) {
  return [
    {
      label: t('pages.projects.action'),
      value: PROJECT_COLUMN.ACTION
    },
    {
      label: t('pages.projects.number'),
      value: PROJECT_COLUMN.NUMBER
    },
    {
      label: t('pages.projects.project'),
      value: PROJECT_COLUMN.NAME
    },
    {
      label: t('pages.projects.last_update'),
      value: PROJECT_COLUMN.UPDATED
    },
    {
      label: t('pages.projects.project_manager'),
      value: PROJECT_COLUMN.MANAGER
    },
    {
      label: t('pages.projects.mainCustomer'),
      value: PROJECT_COLUMN.MAIN_CUSTOMER
    },
    {
      label: t('pages.projects.saler'),
      value: PROJECT_COLUMN.SALER
    },
    {
      label: t('pages.projects.active'),
      value: PROJECT_COLUMN.ACTIVE
    },
    {
      label: t('pages.projects.start_date'),
      value: PROJECT_COLUMN.START_DATE
    },
    {
      label: t('pages.projects.end_date'),
      value: PROJECT_COLUMN.END_DATE
    },
    {
      label: t('pages.projects.phase'),
      value: PROJECT_COLUMN.PHASE
    },
    {
      label: t('pages.projects.street'),
      value: PROJECT_COLUMN.STREET
    },
    {
      label: t('pages.projects.zip'),
      value: PROJECT_COLUMN.ZIP
    },
    {
      label: t('pages.projects.city'),
      value: PROJECT_COLUMN.CITY
    },
    {
      label: t('pages.projects.country'),
      value: PROJECT_COLUMN.COUNTRY
    },
    {
      label: t('pages.projects.longitude'),
      value: PROJECT_COLUMN.LONGITUDE
    },
    {
      label: t('pages.projects.latitude'),
      value: PROJECT_COLUMN.LATITUDE
    }
  ]
}

export function getProjectActiveOptions(t: ReturnType<typeof useL10n>['t']) {
  return [
    { label: t('global.yes'), value: '1' },
    { label: t('global.no'), value: '0' }
  ]
}

export function getRevenueTextColor(revenue: number) {
  if (revenue > 0) return 'text-green-600'
  if (revenue < 0) return 'text-red-600'
  return 'text-gray-600'
}

export enum PROJECT_SETTINGS_TAB {
  SETTINGS = 'SETTINGS',
  CATEGORIES = 'CATEGORIES',
  PHASES = 'PHASES',
  FOLDER = 'FOLDER'
}

export const projectSettingsTabs = [
  {
    id: PROJECT_SETTINGS_TAB.SETTINGS,
    labelKey: 'pages.projectsSettings.settings',
    route: '/settings/projects'
  },
  {
    id: PROJECT_SETTINGS_TAB.CATEGORIES,
    labelKey: 'pages.projectsSettings.categories',
    route: '/settings/projects/project-type'
  },
  {
    id: PROJECT_SETTINGS_TAB.PHASES,
    labelKey: 'pages.projectsSettings.phases',
    route: '/settings/projects/phases'
  },
  {
    id: PROJECT_SETTINGS_TAB.FOLDER,
    labelKey: 'pages.projectsSettings.folder',
    route: '/settings/projects/folder'
  }
]
